import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

function FormatoFechaConHora(value) {
    const fecha = new Date(value);
    return format(fecha, "dd-MMMM-yyyy HH:mm:ss", { locale: es }).toUpperCase();
}

function calcularAnchoProporcional(base64, alturaFija) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const ancho = img.naturalWidth && img.naturalHeight
                ? (img.naturalWidth * alturaFija) / img.naturalHeight
                : 50;
            resolve(ancho);
        };
        img.onerror = () => resolve(50);
        img.src = base64;
    });
}

function detectarFormatoImagen(base64) {
    if (base64.startsWith('data:image/png'))  return 'PNG';
    if (base64.startsWith('data:image/jpeg')) return 'JPEG';
    if (base64.startsWith('data:image/jpg'))  return 'JPEG';
    if (base64.startsWith('data:image/gif'))  return 'GIF';
    if (base64.startsWith('data:image/webp')) return 'WEBP';
    return 'PNG';
}

const CatalogoCuentasPdf = async (objCuentas, objEmpresa, objColor) => {
    return new Promise(async (resolve, reject) => {
        try {
            const doc = new jsPDF({ format: 'letter' });

            const color               = objColor || objEmpresa?.color || '#662e91';
            const logoBase64          = objEmpresa?.logo?.base64 || '';
            const fechaHoraGeneracion = FormatoFechaConHora(new Date());

            const margenIzq = 12;
            const margenDer = 12;
            const xDer      = 215 - margenDer;

            // ── CABECERA ──────────────────────────────────────────────────
            let y = 14;

            if (logoBase64 !== '') {
                const alturaLogo = 20;
                const formatoImg = detectarFormatoImagen(logoBase64);
                const anchoLogo  = await calcularAnchoProporcional(logoBase64, alturaLogo);
                doc.addImage(logoBase64, formatoImg, margenIzq, y, anchoLogo, alturaLogo);
            }

            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text('Catálogo de Cuentas', xDer, y, { align: 'right' });

            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.text((objEmpresa?.rfc || '') + ' | ' + (objEmpresa?.nombre || ''), xDer, y += 6, { align: 'right' });

            y += 10;

            // ── TABLA ─────────────────────────────────────────────────────
            doc.autoTable({
                startY: y,
                head: [[
                    { content: 'Núm. Cuenta', styles: { halign: 'left'  } },
                    { content: 'Descripción', styles: { halign: 'left'  } },
                    { content: 'Cuenta SAT',  styles: { halign: 'left'  } },
                ]],
                body: objCuentas.map(c => [
                    { content: c.numCuenta || '',                                  styles: { halign: 'left' } },
                    { content: c.descripcion || '',                                styles: { halign: 'left' } },
                    { content: c.numCuentaSat?.cuenta || c.numCuentaSat || '',     styles: { halign: 'left' } },
                ]),
                styles: {
                    fontSize: 7,
                    cellPadding: 1,
                    overflow: 'linebreak',
                },
                headStyles: {
                    fillColor: color,
                    textColor: '#ffffff',
                    fontStyle: 'bold',
                },
                alternateRowStyles: { fillColor: '#f4f4f4' },
                // columnStyles: {
                //     0: { cellWidth: 28  },
                //     1: { cellWidth: 100 },
                //     2: { cellWidth: 60  },
                // },
                margin: { left: margenIzq, right: margenDer },
            });

            // ── PIE DE PÁGINA ─────────────────────────────────────────────
            const totalPages = doc.internal.getNumberOfPages();
            const pageH      = doc.internal.pageSize.getHeight();
            const pageW      = doc.internal.pageSize.getWidth();

            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.setFont('helvetica', 'italic');
                doc.setFontSize(8);
                doc.setTextColor(150);
                doc.setDrawColor(color);
                doc.setLineWidth(0.3);
                doc.line(margenIzq, pageH - 16, pageW - margenDer, pageH - 16);
                doc.text('Generado: ' + fechaHoraGeneracion, margenIzq, pageH - 8, { align: 'left' });
                doc.text('Documento generado por ContaGo', pageW / 2, pageH - 8, { align: 'center' });
                doc.text('Página ' + i + ' de ' + totalPages, pageW - margenDer, pageH - 8, { align: 'right' });
            }

            const base64 = doc.output('datauristring');
            resolve(base64);
        } catch (error) {
            console.error(error);
            reject(error);
        }
    });
};

export { CatalogoCuentasPdf };